import { render, staticRenderFns } from "./MateriasManagement.vue?vue&type=template&id=6825664c&"
import script from "./MateriasManagement.vue?vue&type=script&lang=js&"
export * from "./MateriasManagement.vue?vue&type=script&lang=js&"
import style0 from "./MateriasManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports